import React, {useEffect, useState} from 'react';
import {makeStyles, Theme, createStyles} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import {Backdrop, Button, Fade, useMediaQuery, useTheme} from "@material-ui/core";
import {GrClose} from "react-icons/gr";

// function rand() {
//     return Math.round(Math.random() * 20) - 10;
// }

function getModalStyle() {
    const top = 40;//+ rand();
    const left = 47;//+ rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        close_modal_icon: {
            position: 'absolute',
            top: 0,
            right: 0,
            padding: '1rem',
            fontSize: '1.5em',
            cursor: 'pointer'
        },
        paper: {
            position: 'absolute',
            width: 700,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            maxHeight: '80%',
            overflowY: 'auto',
            textAlign: 'center',
            [theme.breakpoints.only("xs")]: {
                width: '100%',
                height: '100vh',
                overflowY: 'auto',
                maxHeight: 'initial'
            }
        },
    }),
);

function StyledModal(props: any = {}) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.only('xs'));

    const [modalStyle, setModalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(false);
    const onClose = props.onClose || (() => {
    })

    // const handleOpen = () => {
    //     //let openState = props.hasOwnProperty('open') ? props.open : true;
    //     setOpen(true);
    // };

    const handleClose = () => {
        setOpen(false);
        onClose();
    };

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    useEffect(() => {

        if (isMobile) {
            setModalStyle({
                top: `50%`,
                left: `50%`,
                transform: `translate(-50%, -50%)`,
            })
        }
    }, [isMobile])

    let title = props.title || '';
    let message = props.message || '';

    if (Array.isArray(message)) {
    }

    // if (!Array.isArray(message)) {
    //     message = [message];
    // }
    // if (!React.isValidElement(message)) {
    //     if (!Array.isArray(message)) {
    //         message = [message]//.split(/(\n|\r\n)+/);
    //     }
    //
    // }

    // message = message.reduce((acc: any[], i: any) => acc.concat(!React.isValidElement(i) ? (i + '').replace(/(<br\s?\/>)+/g, '').split(/(\n|\r\n)+/) : i), []);

    //message.reduce((acc: any[], itm: any) => {
    //                 acc.push(itm);
    //                 acc.push(<br/>);
    //                 return acc;
    //
    const body = (
        <div style={modalStyle} className={classes.paper}>
            {title.length ? <h2 id="modal-title">{title}</h2> : null}
            {React.isValidElement(message) ? <div id='modal-description'>
                {message}
            </div> : <div id='modal-description' dangerouslySetInnerHTML={{__html: message}}/>
            }
            <Button variant="contained" color="primary" type="button" onClick={handleClose}>
                Închide
            </Button>
            <div className={classes.close_modal_icon} onClick={handleClose}><GrClose/></div>
        </div>
    );

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 250,
            }}
        ><Fade in={open}>
            {body}
        </Fade>
        </Modal>
    );
}

export default StyledModal;
